import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/cross.svg';
import { Icon } from '../Icon/Icon';
export const CrossIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
